import React, { memo } from 'react';
import { func, bool, string } from 'prop-types';

import { message } from 'utils/stringUtils';
import UTModal from 'app/components/UTModal';

import FieldDepositWarranty from './components/FieldDepositWarranty';

const PendingWarrantyDepositQuery = ({
  onOpenModal,
  onCloseModal,
  positiveCreditStatus,
  submitForm,
  handleOnSubmit,
  loading
}) => {
  const acceptButton = !positiveCreditStatus &&
    !loading && {
      text: message(`Commons:accept`),
      onPress: submitForm
    };

  const cancelButton = !loading && {
    text: message(`Commons:back`),
    onPress: onCloseModal
  };
  return (
    <UTModal
      isOpen={onOpenModal}
      onRequestClose={onCloseModal}
      title={message(`Sidebar:consultDepositWarranty`)}
      acceptButton={acceptButton}
      cancelButton={cancelButton}
    >
      <FieldDepositWarranty
        pendingWarrantyAmountStatus={positiveCreditStatus}
        onSubmit={handleOnSubmit}
        loading={loading}
      />
    </UTModal>
  );
};

PendingWarrantyDepositQuery.propTypes = {
  onOpenModal: bool,
  onCloseModal: func,
  submitForm: func,
  handleOnSubmit: func,
  positiveCreditStatus: bool || string,
  loading: bool
};
export default memo(PendingWarrantyDepositQuery);
